// Copyright (c) 2024. UpCircle Technology AG.
// All rights reserved. Redistribution in source and/or binary forms,
// with or without modification, is not permitted.

import React from 'react';
import './GroupingOptions.scss';
import { LayersIcon, PackageIcon, AwardIcon } from './icons';
import { useTranslation } from 'react-i18next';

function GroupingOptions({ currentGroup, onGroupChange }) {
  const { t } = useTranslation();
  
  const options = [
    { 
      value: 'all', 
      label: t('group_all_suppliers'), 
      icon: LayersIcon, 
      description: t('group_all_description') 
    },
    { 
      value: 'byMaterial', 
      label: t('group_by_material'), 
      icon: PackageIcon, 
      description: t('group_material_description') 
    },
    { 
      value: 'byRanking', 
      label: t('group_by_ranking'), 
      icon: AwardIcon, 
      description: t('group_ranking_description'),
      disabled: true,
      comingSoon: true
    }
  ];

  return (
    <div className="grouping-options">
      <div className="options-container">
        {options.map((option) => (
          <div 
            key={option.value}
            className={`option-card ${currentGroup === option.value ? 'active' : ''} ${option.disabled ? 'disabled' : ''}`}
            onClick={() => !option.disabled && onGroupChange(option.value)}
            title={option.comingSoon ? t('coming_soon') : option.description}
          >
            <div className="option-content">
              <div className="icon-container">
                <option.icon className="option-icon" />
              </div>
              <div className="option-details">
                <p className="option-label">{option.label}</p>
                <p className="option-description">{option.description}</p>
                {option.comingSoon && <span className="coming-soon-badge">{t('coming_soon')}</span>}
              </div>
            </div>
            {currentGroup === option.value && (
              <div className="active-indicator"></div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default GroupingOptions; 